var exports = {
  "Qs": "GiftAcceptModal.module__content___YldHRV",
  "O8": "GiftAcceptModal.module__loadingContent___YldHRV",
  "Nr": "GiftAcceptModal.module__card___YldHRV",
  "$2": "GiftAcceptModal.module__cardGrid___YldHRV",
  "kJ": "GiftAcceptModal.module__iconCircle___YldHRV",
  "SP": "GiftAcceptModal.module__iconCircleActive___YldHRV",
  "PP": "GiftAcceptModal.module__iconCircleInactive___YldHRV",
  "_O": "GiftAcceptModal.module__iconCircleDisabled___YldHRV",
  "Kk": "GiftAcceptModal.module__icon___YldHRV",
  "m5": "GiftAcceptModal.module__iconError___YldHRV",
  "Ux": "GiftAcceptModal.module__cardContent___YldHRV",
  "DD": "GiftAcceptModal.module__title___YldHRV",
  "jn": "GiftAcceptModal.module__titlePrimary___YldHRV",
  "xP": "GiftAcceptModal.module__titleTertiary___YldHRV",
  "S3": "GiftAcceptModal.module__titleDanger___YldHRV",
  "VA": "GiftAcceptModal.module__subtitle___YldHRV",
  "BK": "GiftAcceptModal.module__helpText___YldHRV",
  "AS": "GiftAcceptModal.module__item___YldHRV",
  "UZ": "GiftAcceptModal.module__itemStage___YldHRV",
  "qC": "GiftAcceptModal.module__itemHeading___YldHRV",
  "YG": "GiftAcceptModal.module__itemType___YldHRV",
  "rv": "GiftAcceptModal.module__itemText___YldHRV",
  "vu": "GiftAcceptModal.module__itemOwned___YldHRV",
  "qr": "GiftAcceptModal.module__footer___YldHRV",
};

module.exports = exports;
